import createSimpleComponent from '../createSimpleComponent'

import cls from './ContentTitle.module.scss'

export default createSimpleComponent({
  displayName: 'ContentTitle',
  className: cls.wrapper,
  Component: 'span',
})
